import { Cornerstone } from '@rpi/api';

export const PROJECT_SORT_VALUES = [
  'last_uploaded',
  'first_uploaded',
  'project_name_asc',
  'project_name_desc',
] as const;
export type ProjectSort = (typeof PROJECT_SORT_VALUES)[number];

export const SORT_OPTION_TO_COMPARE_FN = {
  last_uploaded: (a: Cornerstone.ProjectResult, b: Cornerstone.ProjectResult) =>
    new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  first_uploaded: (
    a: Cornerstone.ProjectResult,
    b: Cornerstone.ProjectResult,
  ) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  project_name_asc: (
    a: Cornerstone.ProjectResult,
    b: Cornerstone.ProjectResult,
  ) => a.title.localeCompare(b.title),
  project_name_desc: (
    a: Cornerstone.ProjectResult,
    b: Cornerstone.ProjectResult,
  ) => b.title.localeCompare(a.title),
};
export const PROJECT_FILTER_VALUES = [
  'all',
  'private',
  'public',
  'books',
  'wall_art',
  'with_bookwright',
  'with_indesign',
  'with_booksmart',
  'with_pdf',
  'with_online',
] as const;

export type ProjectFilter = (typeof PROJECT_FILTER_VALUES)[number];

export const FILTER_OPTION_TO_COMPARE_FN: Record<
  ProjectFilter,
  (project: Cornerstone.ProjectResult) => boolean
> = {
  private: (project: Cornerstone.ProjectResult) => !project.isPublic,
  public: (project: Cornerstone.ProjectResult) => project.isPublic,
  books: (project: Cornerstone.ProjectResult) =>
    project.projectType === 'PDF_BOOK',
  wall_art: (project: Cornerstone.ProjectResult) =>
    project.projectType === 'WALLART',
  with_bookwright: (project: Cornerstone.ProjectResult) =>
    project.creationSource === 'bookwright',
  with_indesign: (project: Cornerstone.ProjectResult) =>
    project.creationSource === 'indesign',
  with_booksmart: (project: Cornerstone.ProjectResult) =>
    project.creationSource === 'booksmart',
  with_pdf: (project: Cornerstone.ProjectResult) =>
    project.creationSource === 'pdf-uploader',
  with_online: (project: Cornerstone.ProjectResult) =>
    project.creationSource === 'online',
  all: (): boolean => true,
};

export const SORT_OPTION_TO_LAST_UPDATED_AT = (
  a: Cornerstone.ProjectResult,
  b: Cornerstone.ProjectResult,
) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
